module.exports = __webpack_public_path__ + "img/content3.9d0c3a29.png";